<template>
  <div
    class="modal fade"
    id="modal"
    ref="modal"
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="bg-body-secondary modal-header py-2">
            {{ $t('Add Item') }}
          <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <select2
            @select="onSelectedInventory"
            :options="select2Items.options"
            :settings="select2Items.setting"
            :placeholder="$t('Add Items') + '...'"
          />
          <div
            class="border border-2 border-success-subtle d-flex justify-content-between mt-3 p-2 rounded-1"
            v-if="selectedItem.id && canIncrease"
          >
            <div>
              <div
                style="font-size: 16px;"
              >
                {{ $t('Unspecified Lot (Found Item)') }}
              </div>
              <div
                style="font-size: 12px;"
              >
                {{ $t('Auto-create new lot using current average cost (+ Stock).') }}
              </div>
            </div>
            <div
              class="align-content-center"
            >
              <button
                type="button"
                class="btn btn-success btn-sm"
                @click="$parent.form.items.find((inventory) => inventory.inventory_id == selectedItem.id && inventory.inventory_lot_id == '')? '': createNewLot(item)"
                :disabled="$parent.form.items.find((inventory) => inventory.inventory_id == selectedItem.id && inventory.inventory_lot_id == '')? true: false"
              >
                {{ $t('Select (Create New Lot)') }}
              </button>
            </div>
          </div>
          <div
            class="mt-3"
            v-if="selectedItem.id && canDecrease"
          >
            {{ $t('Available Lots') }}
            <vue3-easy-data-table
              ref="datatableItems"
              :headers="datatableItems.headers($t)"
              :items="datatableItems.items"
              :loading="datatableItems.loading"
              :theme-color="'#515151'"
              :hide-footer="true"
              :hide-rows-per-page="true"
              :empty-message="$t('No Available Data')"
              :table-min-height="null"
              :body-item-class-name="bodyItemClassNameFunction"
              table-class-name='customize-table-hide-footer-in-modal'
            >
              <template #header-select>
                <input
                  class="form-check-input"
                  type="checkbox"
                  :checked="allSelectableSelected"
                  :indeterminate.prop="someSelected && !allSelectableSelected"
                  :disabled="selectableLots.length === 0"
                  @change="toggleSelectAll"
                />
              </template>
              <template #header-remaining_quantity="header">
                <span class="w-100 text-end">
                  {{ header.text }}
                </span>
              </template>
              <template #header-cost="header">
                <span class="w-100 text-end">
                  {{ header.text }}
                </span>
              </template>
              <template #item-select="item">
                <input
                  v-if="!isLotAdded(item)"
                  class="form-check-input"
                  type="checkbox"
                  :value="item.id"
                  v-model="selectedLots"
                />
                <span v-else class="badge text-bg-success">
                  {{ $t('Added') }}
                </span>
              </template>
              <template #item-expiry_date="item">
                {{ item.expiry_date? formatDate(item.expiry_date): '-' }}
              </template>
              <template #item-remaining_quantity="item">
                {{ formatNumberTwoDigit(item.remaining_quantity) }}
              </template>
              <template #item-unit="item">
                {{ $t(item.unit) }}
              </template>
              <template #item-cost="item">
                {{ formatDigit(item.cost) }}
              </template>
              <template #loading>
                <i class="fa-solid fa-spinner fa-spin fa-2xl" />
              </template>
            </vue3-easy-data-table>
          </div>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">
            {{ $t('Close') }}
          </button>
          <button
            v-if="selectedItem.id && canDecrease"
            type="button"
            class="btn btn-sm btn-danger"
            :disabled="selectedLots.length === 0"
            @click="addSelected"
          >
            {{ $t('Add Selected (Deduct Stock)') }}
            <span v-if="selectedLots.length">({{ selectedLots.length }})</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Vue3EasyDataTable from 'vue3-easy-data-table';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import { AUTH, API_URLS } from '@/services/endpoint/_constants';
import Select2 from 'vue3-select2-component';
import moment from "moment";
import signature  from '@/services/signature';
import ItemForm from './ItemForm.vue';
import numeral from 'numeral';
import FieldItems from "./assets/template/datatable/FieldItems";

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.form)
  },
  props: {
  },
  data() {
    let vm = this;
    return {
      datatableItems: {
        loading: false,
        headers: FieldItems,
        items: [],
        total: 0,
        params: {
          limit: 10,
          page: 1,
          search: ''
        }
      },
      selectedItem: {
        id: ''
      },
      selectedLots: [],
      select2Items: {
        options: [],
        setting: {
          dropdownParent: '#modal',
          minimumResultsForSearch: true,
          multiple: false,
          language: {
            maximumSelected: function (e) {
              return vm.$t('You can only select') + ' ' + e.maximum + ' ' + vm.$t('items');
            },
            loadingMore: function (e) {
              return '<i class="fa-solid fa-spinner fa-spin" />'
            }
          },
          ajax: {
            beforeSend: function (request) {
              request.setRequestHeader('Authorization', 'Bearer ' + AUTH.TOKEN);
            },
            url: AUTH.URL + API_URLS.API_STOCK_ADJUSTMENT_ITEM,
            data: function (params) {
              var query = {
                search: params.term,
                page: params.page || 1,
                branch_id: vm.$parent.form.branch_id,
                limit: 10
              };
              return signature($.param(query)).substring(1);
            },
            processResults: function (data, params) {
              let option = data.data;
              let pageCurrent = data.meta.current_page;
              option = option.map(function(item) {
                return {
                  id: item.id,
                  text: item.name,
                  cost: item.cost,
                  unit_id: item.unit_id,
                  unit_name: item.unit_name,
                  lots: item.lots
                  // disabled: vm.form.items.find((inventory) => inventory.inventory_id == item.id)? true: false
                }
              });
              return {
                results: option,
                pagination: {
                  more: (pageCurrent * 10) < data.meta.total
                }
              }
            }
          }
        }
      },
    }
  },
  components: {
    Ladda,
    Select2,
    Vue3EasyDataTable
  },
  methods: {
    createNewLot() {
      this.$parent.form.items.push({
        inventory_id: this.selectedItem.id,
        inventory_lot_id: '',
        unit_id: this.selectedItem.unit_id,
        name: this.selectedItem.name,
        cost: this.selectedItem.cost,
        lot_number:'',
        unit_name: this.selectedItem.unit_name,
        remaining_quantity: '',
        quantity: '',
        conversion_factor: 1,
        total_cost: 0,
        reason_detail: ''
      });

      $(this.$refs.modal).modal('hide');
    },
    isLotAdded(item) {
      return !!this.$parent.form.items.find(
        (inventory) => inventory.inventory_id == this.selectedItem.id && inventory.inventory_lot_id == item.id
      );
    },
    toggleSelectAll() {
      if (this.allSelectableSelected) {
        this.selectedLots = [];
      } else {
        this.selectedLots = this.selectableLots.map((lot) => lot.id);
      }
    },
    addSelected() {
      this.datatableItems.items.forEach((item) => {
        if (!this.selectedLots.includes(item.id) || this.isLotAdded(item)) return;
        this.$parent.form.items.push({
          inventory_id: this.selectedItem.id,
          inventory_lot_id: item.id,
          unit_id: this.selectedItem.unit_id,
          name: this.selectedItem.name,
          cost: item.cost,
          lot_number: item.lot_number,
          unit_name: item.unit,
          remaining_quantity: item.remaining_quantity,
          quantity: '',
          conversion_factor: item.conversion_factor,
          total_cost: 0,
          reason_detail: ''
        });
      });
      // Keep the modal open so more inventories/lots can be added in one session.
      // Added lots flip to an "Added" badge; clear the working selection.
      this.selectedLots = [];
    },
    bodyItemClassNameFunction(column, rowNumber) {
      let className = 'align-top py-1 px-2';
      const columnCenter = ['select'];
      const columnEnd = ['remaining_quantity', 'cost'];
      if (columnCenter.includes(column)) {
        className += ' text-center';
      }
      if (columnEnd.includes(column)) {
        className += ' text-end';
      }
      return className;
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD');
    },
    async onSelectedInventory(e) {
      this.selectedItem.id = e.id;
      this.selectedItem.name = e.text;
      this.selectedItem.cost = e.cost;
      this.selectedItem.unit_id = e.unit_id;
      this.selectedItem.unit_name = e.unit_name;
      this.datatableItems.items = e.lots;
      this.selectedLots = [];
    },
  },
  async mounted() {
    $(this.$refs.modal).modal('show');

    $(this.$refs.modal).on('shown.bs.modal',async () => {
      this.loading = true;
      try {
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.modal).on('hidden.bs.modal', () => {
      this.$parent.showModalAdditem = false;
    });
  },
  computed: {
    reasonType() {
      return this.$parent?.selectedReasonType || null;
    },
    canIncrease() {
      return this.reasonType === 'increase' || this.reasonType === 'both';
    },
    canDecrease() {
      return this.reasonType === 'decrease' || this.reasonType === 'both';
    },
    selectableLots() {
      return this.datatableItems.items.filter((lot) => !this.isLotAdded(lot));
    },
    someSelected() {
      return this.selectedLots.length > 0;
    },
    allSelectableSelected() {
      const selectable = this.selectableLots;
      return selectable.length > 0 && selectable.every((lot) => this.selectedLots.includes(lot.id));
    },
  }
}
</script>
